"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetMeetingWorkspaceSearchServiceResponse", {
    enumerable: true,
    get: function() {
        return GetMeetingWorkspaceSearchServiceResponse;
    }
});
const _workspace = require("../../../meetings/workspace");
const _base = require("../../base");
const GetMeetingWorkspaceSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _workspace.WorkspaceExtendedModel.array()
});
